var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookOpenLine = function SvgBookOpenLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.4 20.1v1.8h-1.8v-1.8H4.4a.9.9 0 0 1-.9-.9V4.8a.9.9 0 0 1 .9-.9h5.4a3.6 3.6 0 0 1 2.7 1.219A3.6 3.6 0 0 1 15.2 3.9h5.4a.9.9 0 0 1 .9.9v14.4a.9.9 0 0 1-.9.9zm6.3-1.8V5.7h-4.5a1.8 1.8 0 0 0-1.8 1.8v10.8zm-8.1 0V7.5a1.8 1.8 0 0 0-1.8-1.8H5.3v12.6z"
  })));
};
export default SvgBookOpenLine;